import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=0c9a819a&scoped=true&lang=pug&"
import script from "./ImageViewer.vue?vue&type=script&lang=ts&"
export * from "./ImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=0c9a819a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a819a",
  null
  
)

export default component.exports